import StyledTableHead from 'Components/StyledTableHead'
import type {
  AffiliateOrderRefundOptions,
  AffiliateOrderRefundShape
} from 'Services/SalesManagement/Features/Order/types'
import { datetimeFormatter } from 'Util/formatters'
import { LinearProgress, Paper } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import type { FC } from 'react'
import { t } from 'ttag'

const RefundHistoryList: FC<{
  refundList: AffiliateOrderRefundShape[]
  affiliateOrderRefundOptions: { field_choices: AffiliateOrderRefundOptions } | undefined
  isRefundOptionsLoading: boolean
  isRefundListLoading: boolean
}> = ({ refundList, affiliateOrderRefundOptions, isRefundOptionsLoading, isRefundListLoading }) => {
  const getRefundReasonByOptionId = (optionId: number) => {
    const foundOptions = affiliateOrderRefundOptions?.field_choices?.reason.find(
      option => option[0] === optionId
    )
    if (foundOptions) return foundOptions[1]
    return '-'
  }

  const isLoading = isRefundOptionsLoading || isRefundListLoading

  return (
    <TableContainer component={Paper} sx={{ mb: 3 }}>
      <Table>
        <StyledTableHead>
          <TableRow>
            <TableCell colSpan={4}>{t`Refund requests`}</TableCell>
          </TableRow>
        </StyledTableHead>
        {isLoading ? (
          <LinearProgress />
        ) : (
          <>
            <TableHead>
              <TableRow>
                <TableCell>{t`Created`}</TableCell>
                <TableCell>{t`Created by`}</TableCell>
                <TableCell>{t`Reason`}</TableCell>
                <TableCell>{t`Refund target`}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {refundList.length > 0 ? (
                <>
                  {refundList.map(row => (
                    <TableRow key={row.user.id}>
                      <TableCell>{datetimeFormatter(row.created)}</TableCell>
                      <TableCell>{row.user.email}</TableCell>
                      <TableCell>{getRefundReasonByOptionId(row.reason)}</TableCell>
                      <TableCell>{row.ticket_id ? t`Single ticket` : t`Whole order`}</TableCell>
                    </TableRow>
                  ))}
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>{t`No refund requests`}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </>
        )}
      </Table>
    </TableContainer>
  )
}

export { RefundHistoryList }
